import { render, staticRenderFns } from "./OrganistionList.vue?vue&type=template&id=1ecbaef0&scoped=true&"
import script from "./OrganistionList.vue?vue&type=script&lang=js&"
export * from "./OrganistionList.vue?vue&type=script&lang=js&"
import style0 from "./OrganistionList.vue?vue&type=style&index=0&id=1ecbaef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbaef0",
  null
  
)

export default component.exports